import { Card, CardBody, Col } from "reactstrap";
import { H3, LI, UL } from "../../../../AbstractElements";
import { Brand, Brands } from "../../../../Constant";
import { ShippingDetails } from "./ShippingDetails";

const BrandDetail = () => {
  return (
    <Col xl="3" md="6" className="box-col-6">
      <Card>
        <CardBody>
          <div className="filter-block">
            <H3>{Brand}</H3>
            <UL className="simple-list">
              {Brands.map((item, index) => (
                <LI className="pt-3" key={index}>
                  {item}
                </LI>
              ))}
            </UL>
          </div>
        </CardBody>
      </Card>
      <ShippingDetails />
    </Col>
  );
};

export default BrandDetail;
